export default __webpack_public_path__ + "static/media/business-model-navigator.ade9e366.svg";